import { HttpInterceptorFn } from '@angular/common/http'
import { catchError, throwError } from 'rxjs'
import { AuthService } from '../services/auth.service'
import { inject } from '@angular/core'
import { commonUtil } from '../utils/common.util'
import { TranslateService } from '@ngx-translate/core'
import { httpErrorParser } from '../utils/http-error.parser'
import { Router } from '@angular/router'

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  let authService = inject(AuthService)

  if (authService.isLoggedIn()) {
    req = req.clone({
      headers: req.headers.set(
        'Authorization',
        `Bearer ${authService.getToken()}`
      )
    })
  }

  return next(req).pipe(
    catchError((err) => {
      if (err.status === 401) {
        authService.clearToken()
        let router = inject(Router)
        router.navigate(['auth', 'login'])
      }
      return throwError(() => err)
    })
  )
}

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  let transService = inject(TranslateService)
  return next(req).pipe(
    catchError((err) => {
      let errMsg = httpErrorParser.respErrorMessage(err)
      const translationKey = `app.errorMsg.${errMsg}`
      const translatedMsg = transService.instant(translationKey)
      commonUtil.alert(
        translatedMsg === translationKey ? errMsg : translatedMsg,
        'danger'
      )
      return throwError(() => err)
    })
  )
}
